import React from "react";
import DeleteIcon from "../../../../icons/DeleteIcon";
import EditIcon from "../../../../icons/EditIcon";
// import FileMoveItem from "../../../../icons/FileMoveItem";
import LibraryFileIcon from "../../../../icons/LibraryFileIcon";
const LibraryFile = ({
    file,
    onDelete=()=>{},
    onEdit=()=>{},
    // onMove=()=>{}
}) => {
    return (
        <div className='library-file-item'>
            <a href={file.url} target="_blank" className='info-data'>
                <LibraryFileIcon />
                <p>{file.name}</p>
            </a>
            <div className='action-btns'>
                <button onClick={onDelete}><DeleteIcon /></button>
                <button onClick={onEdit}><EditIcon /></button>
                {/* <button onClick={onMove}><FileMoveItem /></button> */}
            </div>

        </div>

    )
}
export default LibraryFile;